module.exports = __webpack_public_path__ + "img/b3cf5f6.png";